import { render, staticRenderFns } from "./SlideEvent.vue?vue&type=template&id=221577f5&scoped=true&"
import script from "./SlideEvent.vue?vue&type=script&lang=js&"
export * from "./SlideEvent.vue?vue&type=script&lang=js&"
import style0 from "./SlideEvent.vue?vue&type=style&index=0&id=221577f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221577f5",
  null
  
)

export default component.exports